module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-跳转-暗.640d9.png";